import { render, staticRenderFns } from "./PaymentReceipts.vue?vue&type=template&id=5743a223&scoped=true&"
import script from "./PaymentReceipts.vue?vue&type=script&lang=js&"
export * from "./PaymentReceipts.vue?vue&type=script&lang=js&"
import style0 from "./PaymentReceipts.vue?vue&type=style&index=0&id=5743a223&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5743a223",
  null
  
)

export default component.exports